import React, { useState, useMemo, useEffect, useRef } from "react";
import {
    FiDelete,
    FiEdit,
    FiFilter,
    FiTrash,
    FiDownload,
} from "react-icons/fi";
import Badge from "../../../../../components/badge/badge";
import { getApiInstance } from "../../../../../utils/api";
import Button from "../../../../../components/button/button";
import Table from "../../../../../components/table/table";
import Notification from "../../../../../components/notification/notification";
import { PiRocket } from "react-icons/pi";
import { IoAdd } from "react-icons/io5";
import Input from "../../../../../components/inputs/input/input";
import InputDropdown from "../../../../../components/inputs/inputDropdown/inputDropdown";
import InputDropdownSimple from "../../../../../components/inputs/inputDropdownSimple/inputDropdownSimple";
import Modal from "../../../../../components/modal/modal";
import InputSearch from "../../../../../components/inputs/inputSearch/inputSearch";
import InputCheckbox from "../../../../../components/inputs/inputCheckbox/inputCheckbox";
import Popup from "../../../../../components/popup/popup";
import CartItem from "../../../../../components/cartItem/cartItem";
import Accordion from "../../../../../components/accordion/accordion";
import Tag from "../../../../../components/tag/tag";
import { searchByKeywords } from "../../../../../utils/searchUtils";
import "./borrador.scss";
import ImageRenderer from "../../../../../components/ImageRender/ImageRender";

const familiaMapping = {
    1: "Mobiliario Central",
    2: "Mobiliario Perimetral",
    3: "Mesas",
    4: "Probadores",
    5: "Caja",
    6: "Dotación",
    7: "Instalaciones",
    8: "Señalética",
    9: "BOH",
};
const categoriasMapping = {
    1: "Tiendas Top",
    2: "Tiendas Light",
    3: "Tiendas Low",
    4: "General",
    5: "Banners",
    6: "Señalización",
    7: "Positive Store",
    8: "Make Up 400",
    9: "Munich",
    10: "Copenhague",
    11: "Miami",
};
const estadoModificacionLabels = {
    1: "Pendiente",
    2: "Modificado",
    3: "Descatalogado",
    4: "Nuevo",
};
const subfamiliaOptions = [
    { value: 1, label: "Tiendas Top" },
    { value: 2, label: "Tiendas Light" },
    { value: 3, label: "Tiendas Low" },
    { value: 4, label: "General" },
    { value: 5, label: "Banners" },
];

const estados = [
    "Pendiente",
    "Modificado",
    "Descatalogado",
    "Nuevo",
    "Sin estado",
];

const estadoDefault = "Sin estado";

const columnsSinTipoDeCambio = [
    {
        key: "rutaImagen",
        label: "Miniatura",
        render: (row) => (
            <ImageRenderer
                thumbnail={row.rutaImagen}
                alt={row.nombreBook || "Sin nombre"}
            />
        ),
    },
    { key: "nombreBook", label: "Nombre", className: "col-nombre" },
    { key: "referencia", label: "Referencia" },
    { key: "nombreFamilia", label: "Familia" },
    {
        key: "variante",
        label: "Variante",
        render: (row) => row.variante || "N/A",
    },
    {
        key: "codFamilias",
        label: "Categoría",
        render: (row) => familiaMapping[row.codFamilia] || "N/A",
    },
    {
        key: "categorias",
        label: "Imagen",
        render: (row) => {
            if (Array.isArray(row.categorias) && row.categorias.length > 0) {
                return row.categorias
                    .map(
                        (categoria) => categoriasMapping[categoria] || categoria
                    )
                    .join(", ");
            } else {
                return "Sin categorías";
            }
        },
    },
    { key: "medida", label: "Unidad de medida" },
    {
        key: "estadoModificacion",
        label: "Estado",
        render: (row) => {
            let variant;
            const estadoModificacionLegible =
                estadoModificacionLabels[row.estadoModificacion] ||
                "Sin estado";

            switch (row.estadoModificacion) {
                case 1: // Pendiente
                    variant = "info";
                    break;
                case 2: // Modificado
                    variant = "warning";
                    break;
                case 3: // Descatalogado
                    variant = "danger";
                    break;
                case 4: // Nuevo
                    variant = "success";
                    break;
                default:
                    variant = "default";
            }

            return (
                <Badge label={estadoModificacionLegible} variant={variant} />
            );
        },
    },
];

export default function Borrador() {
    const [borradores, setBorradores] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchTermDotaciones, setSearchTermDotaciones] = useState("");
    const [selectedMuebles, setSelectedMuebles] = useState([]);
    const [currentBorrador, setCurrentBorrador] = useState({
        codFamilia: "",
        referencia: "",
        nombreBook: "",
        nombreBookIngles: "",
        nombreFamilia: "",
        rutaPlano: "",
        rutaImagen: "",
        codEstadoActual: 1,
        pendienteDeAprobacion: false,
        descripcion: "",
        categorias: [],
        codEstadoModificacion: 4,
        variante: "",
        medida: "Ud.",
        unidadesFijas: 0,
        descripcionUnidadesFijas: "",
    });
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [dotacionesOptions, setDotacionesOptions] = useState([]);
    const [dotacionesSeleccionadas, setDotacionesSeleccionadas] = useState([]);
    const [familiaOptions, setFamiliaOptions] = useState([]);
    const [subfamiliaOptions, setSubfamiliaOptions] = useState([]);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [dotacionesAsignadas, setDotacionesAsignadas] = useState([]);
    const [nombreError, setNombreError] = useState("");
    const [referenciaError, setReferenciaError] = useState("");
    const [imagenError, setImagenError] = useState("");
    const [familiaError, setFamiliaError] = useState("");
    const [subcategoriaError, setSubcategoriaError] = useState("");
    const [planoImagenError, setPlanoImagenError] = useState("");
    const [thumbnail, setThumbnail] = useState("");
    const [planoPreview, setPlanoPreview] = useState("");
    const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
    const [filterVariantes, setFilterVariantes] = useState([]);
    const [filterCategoria, setFilterCategorias] = useState([]);
    const [filterSubcategoria, setFilterSubcategoria] = useState([]);
    const [filterEstado, setFilterEstado] = useState([]);
    const [variantes, setVariantes] = useState([]);
    const [subCategorias, setSubcategorias] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const api = getApiInstance();
    const notificationRef = useRef();
    const [planoFileName, setPlanoFileName] = useState("");
    const [familiaNombreError, setFamiliaNombreError] = useState("");
    const [fileToDelete, setFileToDelete] = useState(null); // { codMueble, tipo }
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [filteredBorradores, setFilteredBorradores] = useState([]);

    const [miniaturaPlaceholderFile, setMiniaturaPlaceholderFile] = useState(
        "Selecciona una imagen"
    );
    const [planoPlaceholderFile, setPlanoPlaceholderFile] = useState(
        "Selecciona un archivo"
    );
    const [familias, setFamilias] = useState([]);
    const [filterFamilia, setFilterFamilia] = useState([]);

    const precargarImagenes = () => {
        // Cargar imagen de la familia si existe
        if (
            currentBorrador?.rutaImagen &&
            !(currentBorrador.rutaImagen instanceof File)
        ) {
            setThumbnail(currentBorrador.rutaImagen); // Precargar la imagen existente
        } else {
            setThumbnail(""); // Limpiar la vista previa si no hay imagen
        }
        // Cargar vista previa del plano si existe (PDF o imagen)
        if (
            currentBorrador?.rutaPlano &&
            !(currentBorrador.rutaPlano instanceof File)
        ) {
            const fileUrl = currentBorrador.rutaPlano;
            if (fileUrl.endsWith(".pdf")) {
                setPlanoPreview(
                    <iframe
                        src={fileUrl}
                        title="Vista previa del PDF"
                        width="100%"
                        height="500px"
                        style={{ border: "none" }}
                    ></iframe>
                );
            } else {
                setPlanoPreview(
                    <img
                        src={fileUrl}
                        alt="Vista previa del plano"
                        style={{ maxWidth: "100%", maxHeight: "500px" }}
                    />
                );
            }
        } else {
            setPlanoPreview("");
        }
    };

    const actionsBorrador = (row) => [
        {
            label: "Modificar",
            onClick: () => {
                setCurrentBorrador(row);
                setIsEditMode(true);
                setIsEditModalOpen(true);
            },
            icon: <FiEdit />,
        },

        {
            label: "Descatalogar",
            onClick: () => handleEliminarMueble(row.codMueble),
            icon: <FiTrash />,
        },

        // {
        //     label: "Ver cambios",
        //     onClick: () => alert(`Ver cambios en ${row.nombreBook}`),
        //     icon: <LuEye />,
        // },
        //TODO: IMPLEMENTAR FUNCION PARA DESPLEGAR DE FORMA INDIVIDUAL
        // {
        //     label: "Listo para desplegar",
        //     icon: <PiRocket />,
        //     onClick: handleListoParaDesplegar,
        // },

        {
            label: "Eliminar de borrador",
            onClick: () => handleEliminarDeBorrador(row.referencia, row),
            icon: <FiDelete />,
        },
        {
            label: "Eliminar mueble",
            onClick: () => handleRemoveNewMueble(row.codMueble),
            icon: <FiDelete />,
            enabled: row.estadoModificacion === 4,
        },
    ];

const filteredDotaciones = useMemo(() => {
        return dotacionesOptions.filter(
            (dotacion) =>
                dotacion.label
                    .toLowerCase()
                    .includes(searchTermDotaciones.toLowerCase()) ||
                dotacion.referencia
                    ?.toLowerCase()
                    .includes(searchTermDotaciones.toLowerCase())
        );
    }, [dotacionesOptions, searchTermDotaciones]);

    const handleSelectMueble = (muebleId) => {
        setSelectedMuebles((prevSelectedMuebles) => {
            const isSelected = prevSelectedMuebles.includes(muebleId);
            const newSelectedMuebles = isSelected
                ? prevSelectedMuebles.filter((id) => id !== muebleId)
                : [...prevSelectedMuebles, muebleId];

            return newSelectedMuebles;
        });
    };

    const fetchBorradores = async () => {
        try {
            const response = await api.get("/api/Mueble/GetBorradores");
            if (response.status === 200 && response.data.length > 0) {
                const borradores = response.data.map((borrador) => ({
                    ...borrador,
                    categorias: borrador.categorias || [],
                    pendienteDeAprobacion: borrador.isPendingApproval === true || borrador.isPendingApproval === "true",
                }));
                setBorradores(borradores);
            } else {
                setBorradores([]);
            }
        } catch (error) {
            console.error("Error al obtener los borradores:", error);
            setBorradores([]);
        }
    };

    useEffect(() => {
        fetchBorradores();
        fetchFamilias();
        fetchSubfamilias();
        fetchDotaciones();
    }, []);
    useEffect(() => {
    setFilteredBorradores(borradores);
}, [borradores]);


    useEffect(() => {
        const allVariantes = borradores
            .map((product) => product.variante)
            .flat()
            .filter((value, index, self) => self.indexOf(value) === index);

        const allSubcategorias = borradores
            .map((product) => categoriasMapping[product.categorias])
            .flat()
            .filter((value, index, self) => self.indexOf(value) === index);

        const allCategorias = borradores
            .map((product) => familiaMapping[product.codFamilia])
            .filter((value, index, self) => self.indexOf(value) === index);

        const allFamilias = borradores
            .map((product) => product.nombreFamilia)
            .filter(
                (value, index, self) =>
                    self.indexOf(value) === index && value != null
            );

        setVariantes(allVariantes);
        setSubcategorias(allSubcategorias);
        setCategorias(allCategorias);
        setFamilias(allFamilias);
    }, [borradores]); //

    useEffect(() => {
        if (isEditMode && currentBorrador?.codMueble) {
            fetchDotacionesAsignadas(currentBorrador.codMueble);
            precargarImagenes();

            if (
                currentBorrador.rutaPlano &&
                !(currentBorrador.rutaPlano instanceof File)
            ) {
                const filePathSegments = currentBorrador.rutaPlano.split("/");
                const fileName = filePathSegments[filePathSegments.length - 1];
                setPlanoFileName(fileName);
            } else {
                setPlanoFileName("");
            }
        } else {
            setThumbnail("");
            setPlanoPreview("");
            setPlanoFileName("");
        }
    }, [isEditMode, currentBorrador?.codMueble]);

    const handleEliminarDeBorrador = async (referencia, mueble) => {
        try {
            const response = await api.patch(
                `/api/Mueble/RestaurarDesdeAuditoria/${mueble.codMueble}`
            );

            if (response.status === 200) {
                setBorradores((prevBorradores) =>
                    prevBorradores.filter(
                        (item) => item.referencia !== referencia
                    )
                );

                notificationRef.current.addNotification(
                    `El mueble con referencia ${referencia} ha sido restaurado y eliminado de borradores.`,
                    "success"
                );
            } else {
                notificationRef.current.addNotification(
                    "Hubo un problema al restaurar el mueble.",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error al restaurar el mueble:", error);
            notificationRef.current.addNotification(
                "Error al restaurar el mueble.",
                "error"
            );
        }
    };

    const handleEliminarMueble = async (muebleId) => {
        try {
            const response = await api.patch(
                `/api/Mueble/ActualizarEstadoModificacion/${muebleId}`,
                JSON.stringify(3),
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                notificationRef.current.addNotification(
                    "Estado de modificación actualizado a 'Descatalogado'.",
                    "success"
                );
                await fetchBorradores();
            } else {
                notificationRef.current.addNotification(
                    "Hubo un problema al actualizar el estado de modificación.",
                    "error"
                );
            }
        } catch (error) {
            console.error(
                "Error al actualizar el estado de modificación:",
                error
            );
            notificationRef.current.addNotification(
                "Error al actualizar el estado de modificación.",
                "error"
            );
        }
    };

    const fetchFamilias = async () => {
        try {
            const response = await api.get("/api/Familia/GetAllFamilias");
            const familias = response.data.map((familia) => ({
                label: familia.nombreFamilia,
                value: familia.codFamilia,
            }));
            console.log("Familias cargadas:", familias);
            setFamiliaOptions(familias);
        } catch (error) {
            console.error("Error al obtener las familias:", error);
        }
    };

    const fetchSubfamilias = async () => {
        try {
            const response = await api.get("/api/Categoria/GetSubfamilias");
            const subfamilias = response.data.map((subfamilia) => ({
                label: subfamilia.nombreSubfamilia,
                value: subfamilia.codCategoria,
            }));
            setSubfamiliaOptions(subfamilias);
        } catch (error) {
            console.error("Error al obtener las subfamilias:", error);
        }
    };
    const fetchDotaciones = async () => {
        try {
            const response = await api.get("/api/Dotacion/GetAllDotaciones");
            const dotaciones = response.data.map((dotacion) => ({
                label: dotacion.nombreDotacion,
                value: dotacion.codDotacion,
                referencia: dotacion.referencia,
            }));
            setDotacionesOptions(dotaciones);
            console.log("Dotaciones recibidas:", dotaciones);
        } catch (error) {
            console.error("Error al obtener las dotaciones:", error);
        }
    };

    const handleListoParaDesplegar = async () => {
        if (selectedMuebles.length === 0) {
            notificationRef.current.addNotification(
                "Selecciona al menos un mueble para cambiar su estado a 'Listo para desplegar'.",
                "warning"
            );
            return;
        }

        const mueblesNumeros = selectedMuebles.map(Number);

        try {
            const requestBody = { codMuebles: mueblesNumeros };

            const response = await api.patch(
                "/api/Mueble/CambiarEstadoAListoParaDesplegar",
                requestBody
            );

            if (response.status === 200) {
                notificationRef.current.addNotification(
                    "Muebles cambiados a 'Listo para desplegar' correctamente.",
                    "success"
                );
                await fetchBorradores();
            } else {
                notificationRef.current.addNotification(
                    "Hubo un problema al cambiar el estado de los muebles.",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error al cambiar el estado de los muebles:", error);
            notificationRef.current.addNotification(
                "Error al cambiar el estado de los muebles.",
                "error"
            );
        }
    };

    const asignarDotaciones = async () => {
        if (dotacionesAsignadas.length === 0) {
            notificationRef.current.addNotification(
                "Debes seleccionar al menos una dotación para asignar.",
                "warning"
            );
            return;
        }

        try {
            const requestBody = dotacionesAsignadas.map((dotacion) => ({
                codDotacion: dotacion.codDotacion,
                unidades: dotacion.unidades,
                referencia: dotacion.referencia,
            }));

            const response = await api.post(
                `/api/Mueble/AsignarDotaciones/${currentBorrador.codMueble}`,
                requestBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                notificationRef.current.addNotification(
                    "Dotaciones asignadas correctamente.",
                    "success"
                );

                await fetchDotacionesAsignadas(currentBorrador.codMueble);

                setPopupOpen(false);
            }
        } catch (error) {
            console.error("Error al asignar las dotaciones:", error);
            notificationRef.current.addNotification(
                "Error al asignar las dotaciones.",
                "error"
            );
        }
    };

    const asignarDotacionesButton = () => {
        setPopupOpen(true);
    };

    const handleSaveChanges = async () => {
        setNombreError("");
        setReferenciaError("");
        setImagenError("");
        setFamiliaError("");
        setSubcategoriaError("");
        setPlanoImagenError("");
        setFamiliaNombreError("");

        // Validaciones
        let hasError = false;
        if (!currentBorrador.nombreBook) {
            setNombreError("El campo nombre es obligatorio.");
            hasError = true;
        }
        if (!currentBorrador.referencia) {
            setReferenciaError("El campo referencia es obligatorio.");
            hasError = true;
        }
        if (!currentBorrador.nombreFamilia) {
            setFamiliaNombreError("El campo familia es obligatorio.");
            hasError = true;
        }
        if (!currentBorrador.codFamilia) {
            setFamiliaError("El campo categoría es obligatorio.");
            hasError = true;
        }
        if (currentBorrador.categorias.length === 0) {
            setSubcategoriaError("Debe seleccionar al menos una subcategoría.");
            hasError = true;
        }

        if (hasError) return;

        try {
            const formData = new FormData();

            formData.append(
                "CodMueble",
                currentBorrador.codMueble?.toString() || "0"
            );
            formData.append(
                "CodFamilia",
                currentBorrador.codFamilia?.toString() || "0"
            );
            formData.append(
                "NombreFamilia",
                currentBorrador.nombreFamilia || ""
            );
            formData.append("Referencia", currentBorrador.referencia || "");
            formData.append("NombreBook", currentBorrador.nombreBook || "");
            formData.append("NombreBookIngles", currentBorrador.nombreBookIngles || "");
            formData.append("Variante", currentBorrador.variante || "");
            formData.append("Descripcion", currentBorrador.descripcion || "");
            formData.append("CodEstadoModificacion", isEditMode ? "2" : "4");
            formData.append(
                "PendienteDeAprobacion",
                currentBorrador.pendienteDeAprobacion ? "true" : "false"
            );
            formData.append("Medida", currentBorrador.medida || "Ud.");

            const unidadesFijas = currentBorrador.unidadesFijas ?? 0;
            formData.append("UnidadesFijas", unidadesFijas.toString());
            formData.append(
                "DescripcionUnidadesFijas",
                currentBorrador.descripcionUnidadesFijas || ""
            );

            if (
                currentBorrador.categorias &&
                currentBorrador.categorias.length > 0
            ) {
                const categoriasString = currentBorrador.categorias.join(",");
                formData.append("categorias", categoriasString);
            }

            if (currentBorrador.rutaImagen instanceof File) {
                formData.append("RutaImagen", currentBorrador.rutaImagen);
            } else if (currentBorrador.rutaImagen) {
                formData.append("RutaImagenUrl", currentBorrador.rutaImagen);
            }

            if (currentBorrador.rutaPlano instanceof File) {
                formData.append("RutaPlano", currentBorrador.rutaPlano);
            } else if (currentBorrador.rutaPlano) {
                formData.append("RutaPlanoUrl", currentBorrador.rutaPlano);
            }

            console.log("--- Datos a enviar ---");
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                transformRequest: (data, headers) => {
                    if (data instanceof FormData) {
                        return data;
                    }
                    return JSON.stringify(data);
                },
            };

            let response;
            if (isEditMode) {
                response = await api.put(
                    `/api/Mueble/${currentBorrador.codMueble}`,
                    formData,
                    config
                );
            } else {
                response = await api.post(`/api/Mueble`, formData, config);
            }

            // Manejo de la respuesta
            if (response.status === 200) {
                notificationRef.current.addNotification(
                    isEditMode
                        ? "Mueble actualizado correctamente."
                        : "Mueble creado correctamente.",
                    "success"
                );
                setIsEditModalOpen(false);
                await fetchBorradores();
            } else {
                throw new Error(`Respuesta inesperada: ${response.status}`);
            }
        } catch (error) {
            console.error("Error completo:", error);

            let errorMessage = "Hubo un error al guardar el mueble.";

            if (error.response) {
                console.error("Detalles del error:", error.response.data);

                if (error.response.data.includes("UnidadesFijas")) {
                    errorMessage =
                        "Error en las unidades fijas. Asegúrese de enviar un valor numérico válido.";
                } else {
                    errorMessage += ` Detalles: ${JSON.stringify(
                        error.response.data
                    )}`;
                }
            } else if (error.message) {
                errorMessage += ` ${error.message}`;
            }

            notificationRef.current.addNotification(errorMessage, "error");
        }
    };

    const handleImageChange = (e) => {
        if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
            console.error("No se seleccionó ningún archivo de imagen");
            return;
        }

        const file = e.target.files[0];

        const validTypes = ["image/jpeg", "image/png", "image/gif"];
        if (!validTypes.includes(file.type)) {
            notificationRef.current.addNotification(
                "Formato de imagen no válido. Use JPEG, PNG o GIF",
                "error"
            );
            return;
        }

        const maxSize = 5 * 1024 * 1024;

        if (file.size > maxSize) {
            notificationRef.current.addNotification(
                "La imagen es demasiado grande (máximo 5MB)",
                "error"
            );
            return;
        }

        try {
            setMiniaturaPlaceholderFile(file.name);
            const fileUrl = URL.createObjectURL(file);
            setThumbnail(fileUrl);

            setCurrentBorrador((prev) => {
                const defaultState = {
                    codFamilia: "",
                    referencia: "",
                    nombreBook: "",
                    nombreBookIngles: "",
                    nombreFamilia: "",
                    rutaPlano: "",
                    rutaImagen: "",
                    descripcion: "",
                    categorias: [],
                    variante: "",
                    medida: "Ud.",
                    unidadesFijas: 0,
                    descripcionUnidadesFijas: "",
                };

                return {
                    ...(prev || defaultState),
                    rutaImagen: file,
                };
            });
        } catch (error) {
            console.error("Error al procesar la imagen:", error);
            notificationRef.current.addNotification(
                "Error al cargar la imagen",
                "error"
            );
        }
    };

    const handlePlanoChange = (e) => {
        if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
            console.error("No se seleccionó ningún archivo de plano");
            return;
        }

        const file = e.target.files[0];

        const validTypes = ["application/pdf", "image/jpeg", "image/png"];
        if (!validTypes.includes(file.type)) {
            notificationRef.current.addNotification(
                "Formato de archivo no válido. Use PDF, JPEG o PNG",
                "error"
            );
            return;
        }

        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            notificationRef.current.addNotification(
                "El archivo es demasiado grande (máximo 10MB)",
                "error"
            );
            return;
        }

        try {
            setPlanoPlaceholderFile(file.name);
            setPlanoFileName(file.name);
            const fileUrl = URL.createObjectURL(file);

            if (file.type === "application/pdf") {
                setPlanoPreview(
                    <iframe
                        src={fileUrl}
                        title="Vista previa del PDF"
                        width="100%"
                        height="500px"
                        style={{ border: "none" }}
                    />
                );
            } else {
                setPlanoPreview(
                    <img
                        src={fileUrl}
                        alt="Vista previa del plano"
                        style={{ maxWidth: "100%", maxHeight: "500px" }}
                    />
                );
            }

            setCurrentBorrador((prev) => {
                const defaultState = {
                    codFamilia: "",
                    referencia: "",
                    nombreBook: "",
                    nombreBookIngles: "",
                    nombreFamilia: "",
                    rutaPlano: "",
                    rutaImagen: "",
                    descripcion: "",
                    categorias: [],
                    variante: "",
                    medida: "Ud.",
                    unidadesFijas: 0,
                    descripcionUnidadesFijas: "",
                };

                return {
                    ...(prev || defaultState),
                    rutaPlano: file,
                };
            });
        } catch (error) {
            console.error("Error al procesar el plano:", error);
            notificationRef.current.addNotification(
                "Error al cargar el plano",
                "error"
            );
        }
    };

    const handleSelectFamilia = (selectedOption) => {
        setCurrentBorrador((prev) => ({
            ...prev,
            codFamilia: selectedOption.value,
        }));
    };

    const handleToggleDotacion = (dotacion) => {
        if (!dotacion?.value) {
            console.error(
                "Dotación inválida en handleToggleDotacion:",
                dotacion
            );
            return;
        }

        setDotacionesAsignadas((prev) => {
            if (!Array.isArray(prev)) {
                console.error("dotacionesAsignadas no es un array:", prev);
                return prev || [];
            }

            const isSelected = prev.some(
                (d) => d?.codDotacion === dotacion.value
            );

            if (isSelected) {
                return prev.filter((d) => d?.codDotacion !== dotacion.value);
            } else {
                return [
                    ...prev,
                    {
                        codDotacion: dotacion.value,
                        unidades: 1,
                        nombreDotacion: dotacion.label,
                        referencia: dotacion.referencia || "",
                    },
                ];
            }
        });
    };

    const handleQuantityChange = (dotacion, newQuantity) => {
        setDotacionesAsignadas((prev) => {
            if (!Array.isArray(prev)) return prev || [];

            return prev.map((d) => {
                if (!d || d.codDotacion !== dotacion.codDotacion) return d;

                return {
                    ...d,
                    unidades: newQuantity,
                };
            });
        });
    };

    const fetchDotacionesAsignadas = async (codMueble) => {
        try {
            const response = await api.get(
                `/api/Mueble/GetDotacionesPorMueble/${codMueble}`
            );

            if (response.status === 200 && Array.isArray(response.data)) {
                const dotaciones = response.data
                    .map((dotacion) => ({
                        codDotacion: dotacion?.codDotacion || "",
                        nombreDotacion:
                            dotacion?.nombreDotacion || "Sin nombre",
                        unidades: dotacion?.unidades || 0,
                        referencia: dotacion?.referencia || "Sin referencia",
                    }))
                    .filter((dotacion) => dotacion.codDotacion); // Filtramos elementos sin codDotacion

                setDotacionesAsignadas(dotaciones);
            } else {
                console.error("Respuesta inválida de la API:", response);
                setDotacionesAsignadas([]);
            }
        } catch (error) {
            console.error("Error al obtener las dotaciones asignadas:", error);
            setDotacionesAsignadas([]);
        }
    };

    const handleRemoveDotacion = async (codDotacion) => {
        try {
            const response = await api.delete(
                `/api/Mueble/EliminarDotacion/${currentBorrador.codMueble}/${codDotacion}`
            );

            if (response.status === 200) {
                setDotacionesAsignadas((prev) =>
                    prev.filter(
                        (dotacion) => dotacion.codDotacion !== codDotacion
                    )
                );
                notificationRef.current.addNotification(
                    "Dotación eliminada correctamente.",
                    "success"
                );
            } else {
                alert("Hubo un problema al eliminar la dotación.");
            }
        } catch (error) {
            console.error("Error al eliminar la dotación:", error);
            alert("Error al eliminar la dotación.");
        }
    };

    const handleSaveDotacionesChanges = async () => {
        console.log("Dotaciones asignadas al confirmar:", dotacionesAsignadas);
        try {
            const requestBody = dotacionesAsignadas.map((dotacion) => ({
                codDotacion: dotacion.codDotacion,
                unidades: dotacion.unidades,
            }));

            const response = await api.put(
                `/api/Mueble/ActualizarUnidadesDotaciones/${currentBorrador.codMueble}`,
                requestBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                notificationRef.current.addNotification(
                    "Unidades de dotaciones actualizadas correctamente.",
                    "success"
                );
            } else {
                alert(
                    "Hubo un problema al actualizar las unidades de las dotaciones."
                );
            }
        } catch (error) {
            console.error(
                "Error al actualizar las unidades de las dotaciones:",
                error
            );
            alert("Error al actualizar las unidades de las dotaciones.");
        }
    };

    const openCreateModal = () => {
        setIsEditMode(false);
        // Reinicia completamente el estado
        setCurrentBorrador({
            codFamilia: "",
            referencia: "",
            nombreBook: "",
            nombreBookIngles: "",
            nombreFamilia: "",
            rutaPlano: "",
            rutaImagen: "",
            codEstadoActual: 1,
            pendienteDeAprobacion: false,
            descripcion: "",
            categorias: [],
            codEstadoModificacion: 4,
            variante: "",
            medida: "Ud.",
            unidadesFijas: 0,
            descripcionUnidadesFijas: "",
        });
        setThumbnail("");
        setPlanoPreview("");
        setPlanoFileName("");
        setMiniaturaPlaceholderFile("Selecciona una imagen");
        setPlanoPlaceholderFile("Selecciona un archivo");
        setIsEditModalOpen(true);
    };

    const closeModal = () => {
        setIsEditModalOpen(false);
        setCurrentBorrador(null);
        setThumbnail("");
        setPlanoPreview("");
        setMiniaturaPlaceholderFile("Selecciona una imagen");
        setPlanoPlaceholderFile("Selecciona un archivo");
    };

    const closeFiltersModal = () => {
        setIsFiltersModalOpen(false);
    };

    const openFiltersModal = () => {
        setIsFiltersModalOpen(true);
    };

    const handleAcceptFilters = () => {
        closeFiltersModal();
    };

    const handleCleanFilter = () => {
        setFilterVariantes([]);
        setFilterCategorias([]);
        setFilterSubcategoria([]);
        setFilterEstado([]);
        setFilterFamilia([]);
    };

    const handleSelectVariante = (varianteName) => {
        setFilterVariantes((prevSelected) => {
            // Verificar si la variante ya está en la lista
            if (prevSelected.includes(varianteName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter(
                    (variante) => variante !== varianteName
                );
            } else {
                // Si no está, agregarla
                return [...prevSelected, varianteName];
            }
        });
    };

    const handleSelectCategoria = (categoriaName) => {
        setFilterCategorias((prevSelected) => {
            // Verificar si la categoria ya está en la lista
            if (prevSelected.includes(categoriaName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter(
                    (categoria) => categoria !== categoriaName
                );
            } else {
                // Si no está, agregarla
                return [...prevSelected, categoriaName];
            }
        });
    };

    const handleSelectSubcategoria = (subcategoriaName) => {
        setFilterSubcategoria((prevSelected) => {
            // Verificar si la subcategoria ya está en la lista
            if (prevSelected.includes(subcategoriaName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter(
                    (subcategoria) => subcategoria !== subcategoriaName
                );
            } else {
                // Si no está, agregarla
                return [...prevSelected, subcategoriaName];
            }
        });
    };

    const handleSelectEstado = (estadoName) => {
        setFilterEstado((prevSelected) => {
            // Verificar si el estado ya está en la lista
            if (prevSelected.includes(estadoName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter((estado) => estado !== estadoName);
            } else {
                // Si no está, agregarla
                return [...prevSelected, estadoName];
            }
        });
    };

    const handleSelectFamiliaFilter = (familiaName) => {
        setFilterFamilia((prevSelected) => {
            // Verificar si la familia ya está en la lista
            if (prevSelected.includes(familiaName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter(
                    (familia) => familia !== familiaName
                );
            } else {
                // Si no está, agregarla
                return [...prevSelected, familiaName];
            }
        });
    };

    const handleRemoveNewMueble = async (codMueble) => {
        try {
            const response = await api.delete(
                `/api/Mueble/EliminarMueble/${codMueble}`
            );

            if (response.status === 200) {
                setBorradores((prev) =>
                    prev.filter((mueble) => mueble.codMueble !== codMueble)
                );
                notificationRef.current.addNotification(
                    "Mueble eliminado correctamente.",
                    "success"
                );
            } else {
                alert("Hubo un problema al eliminar el mueble.");
            }
        } catch (error) {
            notificationRef.current.addNotification(
                "No se ha podido eliminar el mueble.",
                "error"
            );
        }
    };

    const closePopup = () => {
        setPopupOpen(false);
        setSearchTermDotaciones("");
    };

    const handleDownloadFile = async (codMueble, tipo) => {
        try {
            const response = await api.get(
                `/api/Mueble/DownloadArchivo/${codMueble}/${tipo}`,
                {
                    responseType: "blob",
                }
            );

            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = tipo === "plano" ? "plano.pdf" : "imagen.png";
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error al descargar:", error);
            notificationRef.current?.addNotification(
                "Error al descargar el archivo.",
                "error"
            );
        }
    };

    const handleConfirmDelete = async (e) => {
        e?.preventDefault();

        try {
            const { codMueble, tipo } = fileToDelete;

            if (isEditMode) {
                const response = await api.delete(
                    `/api/Mueble/EliminarArchivo/${codMueble}/${tipo}`
                );

                if (response.status === 200) {
                    notificationRef.current?.addNotification(
                        "Archivo eliminado correctamente.",
                        "success"
                    );

                    if (tipo === "plano") {
                        setCurrentBorrador((prev) => ({
                            ...prev,
                            rutaPlano: null,
                        }));
                        setPlanoFileName("");
                        setPlanoPreview("");
                        setPlanoPlaceholderFile("Selecciona un archivo");
                    } else if (tipo === "imagen") {
                        setCurrentBorrador((prev) => ({
                            ...prev,
                            rutaImagen: null,
                        }));
                        setThumbnail(null);
                        setMiniaturaPlaceholderFile("Selecciona una imagen");
                    }
                }
            } else {
                if (tipo === "plano") {
                    setCurrentBorrador((prev) => ({
                        ...prev,
                        rutaPlano: null,
                    }));
                    setPlanoPreview("");
                    setPlanoPlaceholderFile("Selecciona un archivo");
                } else if (tipo === "imagen") {
                    setCurrentBorrador((prev) => ({
                        ...prev,
                        rutaImagen: null,
                    }));
                    setThumbnail(null);
                    setMiniaturaPlaceholderFile("Selecciona una imagen");
                }
                notificationRef.current?.addNotification(
                    "Archivo eliminado.",
                    "success"
                );
            }
        } catch (error) {
            console.error("Error al eliminar:", error);
            notificationRef.current?.addNotification(
                "Error al eliminar el archivo.",
                "error"
            );
        } finally {
            setIsDeletePopupOpen(false);
            setFileToDelete(null);
        }
    };

    const handleDeleteFile = (codMueble, tipo) => {
        setFileToDelete({ codMueble, tipo });
        setIsDeletePopupOpen(true);
    };
    const handleCancelDelete = () => {
        setIsDeletePopupOpen(false);
        setFileToDelete(null);
    };

const handleSearch = (query) => {
	if (!query.trim()) {
		setFilteredBorradores(borradores);
		return;
	}

	const resultados = searchByKeywords(borradores, query, [
		"referencia",
		"nombreBook",
		"nombreFamilia",
		"descripcion",
		"variante"
	]);

	setFilteredBorradores(resultados);
};

const visibleBorradores = useMemo(() => {
	let filtered = filteredBorradores;

	filtered = filtered
		.filter(
			(product) =>
				filterVariantes.length === 0 ||
				filterVariantes.includes(product.variante)
		)
		.filter(
			(product) =>
				filterCategoria.length === 0 ||
				filterCategoria.includes(familiaMapping[product.codFamilia])
		)
		.filter(
			(product) =>
				filterSubcategoria.length === 0 ||
				product.categorias.some((categoria) =>
					filterSubcategoria.includes(categoria)
				)
		)
		.filter((product) => {
			const estadoActual = estados.includes(
				estadoModificacionLabels[product.estadoModificacion]
			)
				? estadoModificacionLabels[product.estadoModificacion]
				: estadoDefault;

			return (
				filterEstado.length === 0 || filterEstado.includes(estadoActual)
			);
		})
		.filter(
			(product) =>
				filterFamilia.length === 0 ||
				filterFamilia.includes(product.nombreFamilia)
		);

	return filtered;
}, [
	filteredBorradores,
	filterVariantes,
	filterCategoria,
	filterSubcategoria,
	filterEstado,
	filterFamilia
]);


    return (
        <>
            <div className="dashboard-productos__content__table-header">
                <InputSearch
                    context="tableSearch"
                    placeholder="Buscar..."
                    onSearch={handleSearch}
                />
                <div className="dashboard-productos__content__table-header__buttons">
                    <Button
                        onClick={openFiltersModal}
                        label="Filtros"
                        icon={<FiFilter />}
                    />
                    <Button
                        label="Listo para desplegar"
                        icon={<PiRocket />}
                        variant="outline"
                        onClick={handleListoParaDesplegar}
                    />
                    <Button
                        label="Crear mueble"
                        icon={<IoAdd />}
                        variant="filled"
                        onClick={openCreateModal}
                    />
                </div>
            </div>
            <Table
                columns={columnsSinTipoDeCambio}
                actions={actionsBorrador}
                data={visibleBorradores}
                rowKey="id"
                noResultsMessage="No se han encontrado resultados."
                onRowSelect={setSelectedMuebles}
                selectedRows={selectedMuebles}
            />

            <Notification ref={notificationRef} />

            <Modal
                title={isEditMode ? "Editar mueble" : "Crear mueble"}
                isOpen={isEditModalOpen}
                onClose={closeModal}
                onCancel={closeModal}
                onAccept={handleSaveChanges}
            >
                <div className="dashboard-productos__modal">
                    <form className="dashboard-productos__modal__content">
                        <Input
                            type="text"
                            label="Nombre"
                            name="nombre"
                            value={currentBorrador?.nombreBook || ""}
                            onChange={(e) =>
                                setCurrentBorrador({
                                    ...currentBorrador,
                                    nombreBook: e.target.value,
                                })
                            }
                            placeholder="Introduce el nombre del artículo"
                        />
                        {nombreError && <p className="error">{nombreError}</p>}
                        <Input
                            type="text"
                            label="Nombre en inglés"
                            name="nombreBookIngles"
                            value={currentBorrador?.nombreBookIngles || ""}
                            onChange={(e) =>
                                setCurrentBorrador({
                                    ...currentBorrador,
                                    nombreBookIngles: e.target.value,
                                })
                            }
                            placeholder="Introduce el nombre del artículo en inglés"
                        />
                        <Input
                            type="text"
                            label="Referencia"
                            name="referencia"
                            value={currentBorrador?.referencia || ""}
                            onChange={(e) =>
                                setCurrentBorrador({
                                    ...currentBorrador,
                                    referencia: e.target.value,
                                })
                            }
                            placeholder="Introduce la referencia del artículo"
                        />
                        {referenciaError && (
                            <p className="error">{referenciaError}</p>
                        )}
                        <Input
                            type="text"
                            label="Familia"
                            name="nombreFamilia"
                            value={currentBorrador?.nombreFamilia || ""}
                            onChange={(e) =>
                                setCurrentBorrador({
                                    ...currentBorrador,
                                    nombreFamilia: e.target.value,
                                })
                            }
                            placeholder="Introduce el nombre de la familia"
                        />
                        {familiaNombreError && (
                            <p className="error">{familiaNombreError}</p>
                        )}
                        <Input
                            type="text"
                            label="Variante"
                            name="variante"
                            value={currentBorrador?.variante || ""}
                            onChange={(e) =>
                                setCurrentBorrador({
                                    ...currentBorrador,
                                    variante: e.target.value,
                                })
                            }
                            placeholder="Introduce la variante"
                        />
                        <InputDropdownSimple
                            label="Unidad de medida"
                            options={[
                                { value: "Ud.", label: "Ud." },
                                { value: "MI.", label: "MI." },
                                { value: "M2", label: "M2" },
                                { value: "%", label: "%" },
                            ]}
                            value={currentBorrador?.medida || ""}
                            onSelect={(selectedOption) =>
                                setCurrentBorrador({
                                    ...currentBorrador,
                                    medida: selectedOption.value,
                                })
                            }
                            placeholder="Selecciona una unidad de medida"
                        />
                        <InputDropdownSimple
                            label="Categoría"
                            options={familiaOptions}
                            value={
                                familiaOptions.find(
                                    (f) =>
                                        f.value === currentBorrador?.codFamilia
                                ) || ""
                            }
                            onSelect={handleSelectFamilia}
                            placeholder="Selecciona una categoría"
                        />
                        {familiaError && (
                            <p className="error">{familiaError}</p>
                        )}
                        <InputDropdown
                            label="Imagen"
                            withCheckboxes={true}
                            options={subfamiliaOptions}
                            onSelect={(selectedOptions) => {
                                setCurrentBorrador((prev) => ({
                                    ...prev,
                                    categorias: selectedOptions,
                                }));
                            }}
                            value={currentBorrador?.categorias || []}
                            placeholder="Selecciona una o más subcategorías"
                        />
                        {subcategoriaError && (
                            <p className="error">{subcategoriaError}</p>
                        )}

                        <Input
                            type="number"
                            label="Unidades fijas por tienda"
                            placeholder="Número de unidades fijas por tienda"
                            value={currentBorrador?.unidadesFijas ?? 0}
                            onChange={(e) => {
                                const value = parseInt(e.target.value) || 0;
                                setCurrentBorrador({
                                    ...currentBorrador,
                                    unidadesFijas: value,
                                });
                            }}
                            min="0"
                            step="1"
                            onBlur={(e) => {
                                if (!e.target.value) {
                                    setCurrentBorrador({
                                        ...currentBorrador,
                                        unidadesFijas: 0,
                                    });
                                }
                            }}
                        />

                        <Input
                            type="textarea"
                            label="Descripción unidades fijas por tienda"
                            value={
                                currentBorrador?.descripcionUnidadesFijas || ""
                            }
                            onChange={(e) =>
                                setCurrentBorrador({
                                    ...currentBorrador,
                                    descripcionUnidadesFijas: e.target.value,
                                })
                            }
                            placeholder="Descripción de las unidades fijas por tienda"
                        />

                        <Input
                            type="file"
                            label="Miniatura"
                            name="rutaImagen"
                            placeholder={miniaturaPlaceholderFile}
                            onChange={handleImageChange}
                            key={`image-input-${isEditModalOpen}`}
                        />
                        {thumbnail && (
                            <div className="image-preview">
                                <img
                                    src={thumbnail}
                                    alt="Vista previa de imagen"
                                />
                            </div>
                        )}
                        {isEditMode && currentBorrador?.rutaImagen && (
                            <div className="file-actions">
                                <button
                                    type="button"
                                    title="Descargar imagen"
                                    onClick={() =>
                                        handleDownloadFile(
                                            currentBorrador.codMueble,
                                            "imagen"
                                        )
                                    }
                                >
                                    <FiDownload size={16} />
                                </button>
                                <button
                                    type="button"
                                    title="Eliminar imagen"
                                    onClick={() =>
                                        handleDeleteFile(
                                            currentBorrador.codMueble,
                                            "imagen"
                                        )
                                    }
                                >
                                    <FiTrash color="#db3737" size={16} />
                                </button>
                            </div>
                        )}
                        {!isEditMode && thumbnail && (
                            <div className="file-actions">
                                <button
                                    type="button"
                                    title="Eliminar imagen"
                                    onClick={() => {
                                        setCurrentBorrador({
                                            ...currentBorrador,
                                            rutaImagen: null,
                                        });
                                        setThumbnail(null);
                                    }}
                                >
                                    <FiTrash color="#db3737" size={16} />
                                </button>
                            </div>
                        )}

                        {imagenError && <p className="error">{imagenError}</p>}
                        <Input
                            type="file"
                            label="Plano"
                            name="planoImagen"
                            placeholder={planoPlaceholderFile}
                            onChange={handlePlanoChange}
                        />
                        {isEditMode && planoFileName && (
                            <div className="pdf-name file-actions">
                                <span>
                                    Archivo plano actual: {planoFileName}
                                </span>
                                <button
                                    type="button"
                                    title="Descargar plano"
                                    onClick={() =>
                                        handleDownloadFile(
                                            currentBorrador.codMueble,
                                            "plano"
                                        )
                                    }
                                >
                                    <FiDownload size={16} />
                                </button>
                                <button
                                    type="button"
                                    title="Eliminar plano"
                                    onClick={() =>
                                        handleDeleteFile(
                                            currentBorrador.codMueble,
                                            "plano"
                                        )
                                    }
                                >
                                    <FiTrash color="#db3737" size={16} />
                                </button>
                            </div>
                        )}
                        {isDeletePopupOpen && (
                            <Popup
                                type="alert"
                                alertType="warning"
                                titleMessage="Confirmar eliminación"
                                alertMessage="¿Estás seguro de que deseas eliminar este archivo?"
                                onConfirm={handleConfirmDelete}
                                onClose={handleCancelDelete}
                                confirmLabel="Eliminar"
                                cancelLabel="Cancelar"
                            />
                        )}

                        {planoImagenError && (
                            <p className="error">{planoImagenError}</p>
                        )}
                        <Input
                            type="textarea"
                            label="Descripción del artículo"
                            name="descripcion"
                            value={currentBorrador?.descripcion || ""}
                            onChange={(e) =>
                                setCurrentBorrador({
                                    ...currentBorrador,
                                    descripcion: e.target.value,
                                })
                            }
                            placeholder="Escribe una breve descripción del artículo (opcional)"
                        />
                        <InputCheckbox
                            label="Pendiente de aprobación"
                            name="pendienteDeAprobacion"
                            checked={!!currentBorrador?.pendienteDeAprobacion}
                            onChange={(e) => {
                                const newChecked = e.target.checked;
                                setCurrentBorrador((prevBorrador) => ({
                                    ...prevBorrador,
                                    pendienteDeAprobacion: newChecked,
                                }));
                            }}
                        />
                        {isEditMode && (
                            <Button
                                variant="outline"
                                type="button"
                                label="Asignar dotaciones"
                                onClick={asignarDotacionesButton}
                                fullWidth={true}
                            />
                        )}
                        {isEditMode && (
                            <Accordion title="Dotaciones asignadas">
                                <ul className="dotaciones-asignadas">
                                    {dotacionesAsignadas.length > 0 ? (
                                        dotacionesAsignadas.map((dotacion) => (
                                            <CartItem
                                                key={dotacion.codDotacion}
                                                itemName={
                                                    dotacion.nombreDotacion
                                                }
                                                itemRef={dotacion.referencia}
                                                totalItems={dotacion.unidades}
                                                initialQuantity={
                                                    dotacion.unidades
                                                }
                                                showCheckbox={false}
                                                showImage={false}
                                                showRemoveIcon={true}
                                                onQuantityChange={(
                                                    newQuantity
                                                ) =>
                                                    handleQuantityChange(
                                                        dotacion,
                                                        newQuantity
                                                    )
                                                }
                                                onRemove={() =>
                                                    handleRemoveDotacion(
                                                        dotacion.codDotacion
                                                    )
                                                }
                                            />
                                        ))
                                    ) : (
                                        <p>
                                            No hay dotaciones asignadas a este
                                            mueble.
                                        </p>
                                    )}
                                </ul>
                            </Accordion>
                        )}
                        {/* {isEditMode && dotacionesAsignadas.length < 0 && (
                            <Button
                                type="button"
                                onClick={handleSaveDotacionesChanges}
                                label="Aceptar"
                            />
                        )} */}
                    </form>
                </div>
            </Modal>

            <Modal
                title="Filtros"
                isOpen={isFiltersModalOpen}
                onClose={closeFiltersModal}
                onAccept={handleAcceptFilters}
                outlineButtonLabel="Limpiar"
                primaryButtonLabel={`Ver resultados (${visibleBorradores.length})`}
                onCancel={handleCleanFilter}
            >
                <div className="section-header__modal__section">
                    <Accordion title="Variante">
                        <ul className="section-header__modal__section__content">
                            {variantes.map((familia, index) => (
                                <Tag
                                    key={index}
                                    label={familia}
                                    isSelected={filterVariantes.includes(
                                        familia
                                    )}
                                    onSelect={handleSelectVariante}
                                />
                            ))}
                        </ul>
                    </Accordion>
                </div>
                <div className="section-header__modal__section">
                    <Accordion title="Categoría">
                        <ul className="section-header__modal__section__content">
                            {categorias.map((categoria, index) => (
                                <Tag
                                    key={index}
                                    label={categoria}
                                    isSelected={filterCategoria.includes(
                                        categoria
                                    )}
                                    onSelect={handleSelectCategoria}
                                />
                            ))}
                        </ul>
                    </Accordion>
                </div>

                <div className="section-header__modal__section">
                    <Accordion title="Familia">
                        <ul className="section-header__modal__section__content">
                            {familias.map((familia, index) => (
                                <Tag
                                    key={index}
                                    label={familia}
                                    isSelected={filterFamilia.includes(familia)}
                                    onSelect={handleSelectFamiliaFilter}
                                />
                            ))}
                        </ul>
                    </Accordion>
                </div>
                <div className="section-header__modal__section">
                    <Accordion title="Estado">
                        <ul className="section-header__modal__section__content">
                            {estados.map((estado, index) => (
                                <Tag
                                    key={index}
                                    label={estado}
                                    isSelected={filterEstado.includes(estado)}
                                    onSelect={handleSelectEstado}
                                />
                            ))}
                        </ul>
                    </Accordion>
                </div>
            </Modal>
            {isPopupOpen && (
                <Popup
                    type="info"
                    titleMessage="Asignar dotaciones"
                    onClose={closePopup}
                    onConfirm={asignarDotaciones}
                    confirmLabel="Confirmar"
                    cancelLabel="Cancelar"
                    size="XL"
                >
                    <div className="asignar-dotaciones">
                        <div className="asignar-dotaciones__fixed-search">
                            <InputSearch
                                context="tableSearch"
                                placeholder="Buscar..."
                                onSearch={setSearchTermDotaciones}
                            />
                        </div>
                        {filteredDotaciones.length > 0 ? (
                            filteredDotaciones.map((dotacion) => {
                                const dotacionAsignada =
                                    dotacionesAsignadas.find(
                                        (d) => d.codDotacion === dotacion.value
                                    );

                                return (
                                    <CartItem
                                        key={dotacion.value}
                                        itemName={dotacion.label}
                                        itemRef={dotacion.referencia}
                                        showCheckbox={true}
                                        checked={!!dotacionAsignada}
                                        onChange={() =>
                                            handleToggleDotacion(dotacion)
                                        }
                                        initialQuantity={
                                            dotacionAsignada?.unidades || 0
                                        }
                                        onQuantityChange={(newQuantity) => {
                                            if (dotacionAsignada) {
                                                handleQuantityChange(
                                                    dotacionAsignada,
                                                    newQuantity
                                                );
                                            }
                                        }}
                                    />
                                );
                            })
                        ) : (
                            <p className="no-results-message">
                                No se han encontrado resultados
                            </p>
                        )}
                    </div>
                </Popup>
            )}
        </>
    );
}
